import type { ProjectExecute } from "../types/ead-types.ts";

export function canonicalRunSessionKey(executionId: string): string {
  const id = String(executionId || "").trim();
  return id ? `eadproj-exec-${id}` : "";
}

/** Session key for chat/mindmap — gateway value or canonical default. */
export function resolveRunSessionKey(
  ex: Pick<ProjectExecute, "id" | "runSessionKey">,
): string {
  const sk = String(ex.runSessionKey ?? "").trim();
  if (sk) return sk;
  return canonicalRunSessionKey(String(ex.id ?? ""));
}

export function runSessionKeyFromGateway(
  ex: Pick<ProjectExecute, "runSessionKey">,
): boolean {
  return Boolean(String(ex.runSessionKey ?? "").trim());
}

/** True when chat may send (key known; session may still be bootstrapping). */
export function isRunChatSessionLive(
  ex: Pick<ProjectExecute, "id" | "runSessionKey" | "bootstrapPending">,
): boolean {
  if (runSessionKeyFromGateway(ex)) return true;
  if (!ex.bootstrapPending) return true;
  return Boolean(resolveRunSessionKey(ex));
}
